const textOverflowHidden = {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
};

export { textOverflowHidden };
